// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__joOEs","footer":"styles_footer__2luEY"};